import "core-js/es6/map"
import "core-js/es6/set"
import "raf/polyfill"
import React from "react"
import Loadable from "@loadable/component"

import {
  Layout,
  // MainPageHero,
  // MainExistsSince,
  // MainQuotes,
  // EventsPageHero,
  // EventsList,
  // EventsPageEngagement,
  // MainPageProducts,
  // MainEvents,
  // AboutUsHero,
  Spacer,
} from "../"
// import {
//   ContentWithImageOnSide,
//   GeneralPromotionHero,
//   MainSkewedSection,
//   ReachFriendForm,
//   // SkewedSectionWithCard,
//   SocialMediaGrid,
// } from "../RefreshYourFriendContainers"
import {
  language_code_to_static,
  POP_UP_TEXT,
  supported_browsers_list,
} from "../../constants"
import { scrollToRef, getCurrentLanguage, getCookie } from "../../helper"
// import AboutUsSectionBg from "../AboutUsSectionWithBg/AboutUsSectionBg"
// import AboutUsIconSection from "../AboutUsIconSection/AboutUsIconSection"
// import AboutUsBottleSliderSection from "../AboutUsBottleSliderSection/AboutUsBottleSliderSection"
// import AboutUsEngagementSection from "../AboutUsEngagementSection/AboutUsEngagementSection"
import { Modal } from "../../components"
import s from "./PageBuilder.module.scss"

const descriptions = {
  markenwelt: {
    de: `Rivella steht für das unverwechselbare Lebensgefühl der aktiven Schweiz. Erfahre mehr über das beliebteste Schweizer Erfrischungsgetränk.`,
  },
}

class PageBuilder extends React.Component {
  constructor(props) {
    super(props)
    this.pageRefs = []
    let shouldForceWhiteHeader = false
    props.pageContext.childrenData.forEach((c) => {
      if (c.type) {
        if (c.type !== "rivella/spacer") {
          const cRef = React.createRef()
          this.pageRefs.push(cRef)
          c.sectionRef = cRef
        }
        if (c.type === "rivella/hero-with-text") {
          shouldForceWhiteHeader = true
        }
      }
    })
    this.state = {
      iePopUpModal: false,
      shouldForceWhiteHeader,
    }
  }

  componentDidMount = () => {
    if (typeof document !== "undefined" && !!document.documentMode) {
      this.setCookie()
    }

    if (getCookie("ie_popup")) {
      this.setState({ iePopUpModal: true })
    }
  }

  setCookie = () => {
    // Delete any associated cookie
    document.cookie = "ie_popup=; expires=Thu, 01 Jan 1970 00:00:00 UTC"
    const twoWeeksFromToday = new Date(Date.now() + 12096e5)
    document.cookie = "ie_popup=1; expires=" + twoWeeksFromToday
  }

  deleteIEPopUpCookie = () => {
    document.cookie = "ie_popup=; expires=Thu, 01 Jan 1970 00:00:00 UTC"
    this.setState({ iePopUpModal: false })
  }

  scrollToHandler = (currentIndex, options) => {
    const ref =
      typeof this.pageRefs[currentIndex + 1] !== "undefined"
        ? this.pageRefs[currentIndex + 1]
        : null
    scrollToRef(ref, options)
  }
  scrollToSpecificTargetHandler = (targetIndex, options) => {
    const ref =
      typeof this.pageRefs[targetIndex] !== "undefined"
        ? this.pageRefs[targetIndex]
        : null
    scrollToRef(ref, options)
  }

  generateLoadable = (containerName, fileName) => {
    return Loadable(() =>
      import(`../${containerName}/${fileName ? fileName : containerName}`)
    )
  }
  generatePromotionLoadable = (containerName) => {
    return Loadable(() =>
      import(`../RefreshYourFriendContainers/${containerName}/${containerName}`)
    )
  }

  generateHikingLoadable = (containerName, isComponent) => {
    return isComponent
      ? Loadable(() =>
          import(`../../components/${containerName}/${containerName}`)
        )
      : Loadable(() =>
          import(`../HikeAndWinContainers/${containerName}/${containerName}`)
        )
  }

  renderChildren = (childrenData) => {
    let refIndex = -1
    const { location } = this.props
    const defaultProps = {
      location,
    }
    const currentLang = getCurrentLanguage(location)

    return childrenData.map((c, i) => {
      const zIndex = 1000 - i * 50
      ++refIndex
      let C = null
      const specificProps = {}
      switch (c.type) {
        case "rivella/home-hero":
          C = this.generateLoadable("MainPageHero")
          break
        case "rivella/home-exists-since":
          C = this.generateLoadable("MainExistsSince")
          break
        case "rivella/home-main-quotes":
          C = this.generateLoadable("MainQuotes")
          specificProps.lang = currentLang.langHref
          break
        case "rivella/events-page-hero":
          C = this.generateLoadable("EventsPageHero")
          specificProps.onScrollToSpecificTarget =
            this.scrollToSpecificTargetHandler
          break
        case "rivella/events-news-section":
          C = this.generateLoadable("EventsNewsSection")
          break
        case "rivella/events-contests-section":
          C = this.generateLoadable("EventsContestSection")
          break
        case "rivella/events-partners-section":
          C = this.generateLoadable("EventsPartnersSection")
          break
        case "rivella/events-page-list":
          C = this.generateLoadable("EventsList")
          specificProps.rawEvents = this.props.pageContext.rawEvents
          break
        // case "rivella/events-image":
        //   C = this.generateLoadable("EventsImage");
        //   break;
        case "rivella/events-page-engagement":
          C = this.generateLoadable("EventsPageEngagement")
          break
        case "rivella/main-products":
          C = this.generateLoadable("MainPageProducts")
          break
        case "rivella/main-events":
          C = this.generateLoadable("MainEvents")
          specificProps.rawEvents = this.props.pageContext.rawEvents
          break
        case "rivella/about-us-hero":
          C = this.generateLoadable("AboutUsHero")
          break
        case "rivella/about-us-section-with-bg":
          C = this.generateLoadable("AboutUsSectionWithBg", "AboutUsSectionBg")
          break
        case "rivella/about-us-block-text":
          C = this.generateLoadable("AboutUsBlockText")
          break
        case "rivella/about-us-icon-section":
          C = this.generateLoadable("AboutUsIconSection")
          break
        case "rivella/about-us-bottle-slider":
          C = this.generateLoadable("AboutUsBottleSliderSection")
          break
        case "rivella/about-us-engagement":
          C = this.generateLoadable("AboutUsEngagementSection")
          break
        case "rivella/general-promotion-hero":
          C = this.generatePromotionLoadable("GeneralPromotionHero")
          break
        case "rivella/promotion-skewed-section":
          C = this.generatePromotionLoadable("MainSkewedSection")
          break
        case "rivella/content-with-image-on-side":
          C = this.generatePromotionLoadable("ContentWithImageOnSide")
          break
        case "rivella/migros-promo-form":
          C = this.generateLoadable("MigrosPromoForm")
          break
        case "rivella/sup-promo-form":
          C = this.generateLoadable("SupPromoForm")
          break
        case "rivella/reach-friend-form":
          C = this.generatePromotionLoadable("ReachFriendForm")
          break
        case "rivella/hero-with-text":
          C = this.generatePromotionLoadable("HeroWithText")
          break
        case "rivella/alternate-promotion-page":
          C = this.generateLoadable("AlternatePromotionPage")
          break
        case "rivella/skewed-background-hero":
          C = this.generateLoadable("NewPromotionHero")
          break
        case "rivella/skewed-with-bg-color":
          C = this.generateLoadable("NewPromotionSkewed")
          break
        case "rivella/promotion-form":
          C = this.generateLoadable("NewPromotionForm")
          break
        case "rivella/promo-image":
          C = this.generateLoadable("NewPromotionImage")
          break
        case "rivella/refresh-promo-twenty-one":
          C = this.generateLoadable("RefreshPromoTwentyOne")
          break
        case "rivella/refresh-promo-twenty-two":
          C = this.generateLoadable("RefreshPromoTwentyTwo")
          break
        case "rivella/refresh-promo-v5":
          C = this.generateLoadable("RefreshPromoV5")
          break
        case "rivella/refresh-promo-v6":
          C = this.generateLoadable("RefreshPromoV6")
          break
        case "rivella/refresh-ar-promo-twenty-two":
          C = this.generateLoadable("RefreshARPromoTwentyTwo")
          break
        case "rivella/refresh-heissluftballon-twenty-two":
          C = this.generateLoadable("RefreshHeissluftballonTwentyTwo")
          break
        case "rivella/refresh-coop-gastro-twenty-three":
          C = this.generateLoadable("RefreshCoopGastroTwentyThree")
          break
        case "rivella/ski-tickets-2024":
            C = this.generateLoadable("SkiTickets2024")
            break
        case "rivella/nendaz-2024":
            C = this.generateLoadable("Nendaz2024")
            break
        case "rivella/hb-bigbang-2024":
            C = this.generateLoadable("HbBigBang2024")
            break
        case "rivella/xmas-twenty-three":
          C = this.generateLoadable("XmasTwentyThree")
          break
        case "rivella/wander-promo":
          C = this.generateLoadable("WanderPromo")
          break
        case "rivella/refresh-esaf-twenty-two":
          C = this.generateLoadable("RefreshESAFTwentyTwo")
          break
        case "hiking/partner-page-hero":
          C = this.generateHikingLoadable("PartnerPageHero")
          specificProps.itemProp = "primaryImageOfPage"
          break
        case "hiking/rivella-unlimited-section":
          C = this.generateHikingLoadable("RivellaUnlimitedSection")
          specificProps.itemProp = "about"
          break
        case "hiking/rivella-unlimited-partner-section":
          C = this.generateHikingLoadable("RivellaUnlimitedPartnerSection")
          specificProps.itemProp = "about"
          specificProps.itemScope = true
          specificProps.itemType = "https://schema.org/TouristDestination"
          break
        case "hiking/winner-ranking-section":
          C = this.generateHikingLoadable("WinnersRankingSection")
          specificProps.itemScope = true
          specificProps.itemProp = "potentialAction"
          specificProps.itemType = "https://schema.org/Action"
          specificProps.lang = currentLang.langHref
          break
        case "hiking/prize-list-section":
          C = this.generateHikingLoadable("PrizeListSection")
          specificProps.itemProp = "potentialAction"
          break
        case "hiking/discover-destination-section":
          C = this.generateHikingLoadable("DiscoverDestinationSection")
          specificProps.itemProp = "about"
          specificProps.firstSection = true
          break
        case "hiking/discover-destination-map-section":
          C = this.generateHikingLoadable("DiscoverDestinationMapSection")
          specificProps.itemProp = "location"
          specificProps.currentLang = currentLang.combined
          specificProps.firstSection = true
          specificProps.icon_one_img = "map_pin_black.png"
          specificProps.icon_two_img = "map_pin_grey.png"
          break
        case "hiking/experience-section":
          C = this.generateHikingLoadable("ExperienceSection")
          specificProps.baseSlug = currentLang.slug
          specificProps.itemProp = "location"
          break
        case "hiking/how-it-works-section":
          C = this.generateHikingLoadable("HowItWorksSection")
          specificProps.itemProp = "about"
          break
        case "hiking/faq-accordion":
          C = this.generateHikingLoadable("FAQAccordion")
          specificProps.itemProp = "mainContentOfPage"
          break
        case "hiking/impressionen-details-section":
          C = this.generateHikingLoadable("ImpressionenDetailsSection")
          specificProps.itemProp = "abstract"
          break
        case "hiking/intro-info-section":
          C = this.generateHikingLoadable("IntroInfoSection")
          break
        case "hiking/homepage-bottle-section":
          C = this.generateHikingLoadable("HomepageBottleSection")
          break
        case "hiking/win-and-hike-hero":
          C = this.generateHikingLoadable("WinAndHikeHero", true)
          specificProps.hasBigLogo = true

          specificProps.hasSecondaryPathAnimation = childrenData.find(
            (cc) => cc.type === "hiking/account-details"
          )
          specificProps.lang = currentLang.lang
          break
        case "hiking/partner-detail-section":
          C = this.generateHikingLoadable("PartnerDetailSection")
          specificProps.lang = currentLang.lang
          specificProps.itemProp = "about"
          break
        case "hiking/partner-gallery-grid":
          C = this.generateHikingLoadable("PartnerGalleryGrid")
          break
        case "hiking/hiking-code-submission":
          specificProps.isAccountSection = childrenData.find(
            (cc) => cc.type === "hiking/account-details"
          )
          C = this.generateHikingLoadable("WinLoseWrapper")
          break
        case "hiking/hiking-login":
          C = this.generateHikingLoadable("LoginForm")
          break
        case "hiking/account-details":
          C = this.generateHikingLoadable("AccountSection")
          break

        case "hiking/logout-button":
          C = this.generateHikingLoadable("LogoutBtn")
          break
        case "hiking/terms-and-conditions":
          C = this.generateHikingLoadable("Teilnahmebedingungen")
          break
        case "hiking/social-media-gallery-grid":
          C = this.generateHikingLoadable("SocialMediaGalleryGrid")
          break
        case "hiking/hiking-message-box":
          C = this.generateHikingLoadable("HikingMessageBox")
          break
        case "rivella/spacer":
          refIndex--
          return <Spacer key={c.type + i} {...defaultProps} {...c.props} />
        default:
          return null
      }
      if (C) {
        return (
          <C
            key={c.type + i}
            sectionZindex={zIndex}
            sectionRef={this.pageRefs[refIndex]}
            onScrollTo={this.scrollToHandler.bind(this, refIndex)}
            {...specificProps}
            {...defaultProps}
            {...c.props}
          />
        )
      } else return null
    })
  }

  render() {
    const { location } = this.props
    const {
      pageName,
      childrenData,
      headerIsTransparent,
      translations,
      allProducts,
      allEvents,
      allPages,
      siteScope,
    } = this.props.pageContext
    const { iePopUpModal, shouldForceWhiteHeader } = this.state

    const currentLang = getCurrentLanguage(location)
    const languageOptions = {
      currentLang,
      options: translations.map((L) => ({
        ...L,
        ...language_code_to_static[L.language_code],
        slug: `${L.language_code}/${L.slug}`,
      })),
    }

    const pageTitle = pageName?.toLowerCase()
    return (
      <Layout
        pageName={pageName}
        headerIsTransparent={
          shouldForceWhiteHeader ? false : headerIsTransparent
        }
        location={location}
        languageOptions={languageOptions}
        allProducts={allProducts}
        allEvents={allEvents}
        allPages={allPages}
        siteScope={siteScope}
        pageDescription={descriptions[pageTitle]?.[currentLang.lang]}
      >
        {POP_UP_TEXT[currentLang.combined] && (
          <Modal
            onClose={this.deleteIEPopUpCookie}
            className={s.Modal}
            visible={iePopUpModal}
          >
            <div className={s.ModalContent}>
              <span>{POP_UP_TEXT[currentLang.combined].text}</span>
              <ul className={s.SupportedBrowsersList}>
                {supported_browsers_list.map((browser, index) => (
                  <li key={index}>- {browser}</li>
                ))}
              </ul>
              <span>{POP_UP_TEXT[currentLang.combined].suffix}</span>
            </div>
          </Modal>
        )}
        {this.renderChildren(childrenData)}
      </Layout>
    )
  }
}

export default PageBuilder
